import { motion } from "framer-motion";
import { Phone, Mail, Star, MapPin } from "lucide-react";
import { CONTACT, IMAGES } from "../data";
export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Handyman at work"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-brownDark/95 via-brand-brown/85 to-brand-brown/50" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 w-full pt-28 pb-16 grid lg:grid-cols-2 gap-10 lg:gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-xl"
        >
          <div
            data-testid="free-estimate-badge"
            className="inline-flex items-center gap-2 rounded-full bg-brand-olive/90 px-4 py-1.5 text-xs font-semibold tracking-widest uppercase text-brand-bg mb-6"
          >
            <Star size={14} className="fill-current" /> Free Estimate
          </div>

          <p className="text-brand-olive font-medium tracking-widest uppercase text-sm mb-4">
            Salford&apos;s multi-trade handyman
          </p>

          <h1 className="font-display font-extrabold text-[#FCFAF6] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            Your Home,
            <br />
            Done to Perfection.
          </h1>

          <p className="mt-6 text-[#EDE6DA] text-base sm:text-lg leading-relaxed max-w-xl">
            From small fixes to full creative home projects — expert joinery,
            reliable plumbing and safe electrical work, all completed to the
            highest standard. One trusted pair of hands for the lot.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <a
              href={CONTACT.phoneRaw}
              data-testid="hero-call-button"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-olive px-7 py-4 font-semibold text-brand-bg hover:bg-brand-oliveDark hover:scale-105 transition-all shadow-lg"
            >
              <Phone size={18} /> Call {CONTACT.phoneDisplay}
            </a>
            <a
              href={CONTACT.emailLink}
              data-testid="hero-email-button"
              className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-[#FCFAF6]/40 bg-white/5 backdrop-blur px-7 py-4 font-semibold text-[#FCFAF6] hover:bg-white/10 hover:scale-105 transition-all"
            >
              <Mail size={18} /> Email Me
            </a>
          </div>

          <div className="mt-8 flex items-center gap-2 text-[#EDE6DA]/80 text-sm">
            <MapPin size={16} className="text-brand-olive" /> {CONTACT.area}
          </div>
        </motion.div>

        <motion.div
          data-testid="hero-logo"
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.25, ease: "easeOut" }}
          className="flex items-center justify-center w-full max-w-sm sm:max-w-md mx-auto lg:ml-auto lg:mr-0 rounded-3xl bg-[#FBF8F0] p-7 sm:p-9 shadow-[0_24px_60px_rgba(0,0,0,0.35)] ring-1 ring-black/5"
        >
          <img
            src={IMAGES.logo}
            alt="All Done Handyman logo"
            className="w-full object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
};
